import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../app.constant';
import { LocalStorage } from '../../core/helper/localStorage';
import { GenEnum } from '../shared/general.enum';

@Component({
  templateUrl: './sm.component.html',
  styleUrls: [
    './sm.component.css'
  ]
})

export class SmComponent implements OnInit {
  // BODY TAG OPTIONS:
  // =================
  // Apply one or more of the following classes to get the
  // desired effect
  // |---------------------------------------------------------|
  // | SKINS         | skin-blue                               |
  // |               | skin-black                              |
  // |               | skin-purple                             |
  // |               | skin-yellow                             |
  // |               | skin-red                                |
  // |               | skin-green                              |
  // |---------------------------------------------------------|
  // |LAYOUT OPTIONS | fixed                                   |
  // |               | layout-boxed                            |
  // |               | layout-top-nav                          |
  // |               | sidebar-collapse                        |
  // |               | sidebar-mini                            |
  // |---------------------------------------------------------|
  skin: string = "skin-blue";
  layoutOptions: string = "sidebar-mini";

  body = document.getElementsByTagName('body')[0];
  localStorage: any;
  userObj: any;
  employeeview: boolean = false;
  parentview: boolean = false;


  constructor(private router: Router) {
    this.localStorage = AppConstants.injector.get(LocalStorage);
  }

  ngOnInit(): void {
    //add the the body classes
    this.body.classList.add(this.skin);
    this.body.classList.add(this.layoutOptions);
    let user = this.localStorage.get("utuser");
    this.userObj = JSON.parse(user)
    
    if (this.userObj.usercatid === GenEnum.User_Category.Admin || this.userObj.usercatid === GenEnum.User_Category.Employee) {
      this.employeeview = true;
      this.parentview = false;
    }
    else if (this.userObj.usercatid === GenEnum.User_Category.Parent) {
      this.userObj.usercatid === GenEnum.User_Category.Parent
      this.employeeview = false;
      this.parentview = true;
    }
  }

  ngOnDestroy(): void {
    //remove the the body classes
    this.body.classList.remove(this.skin);
    this.body.classList.remove(this.layoutOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/shell/sm/sm.component.ts